/*
 *   File : risk-profile-status.js
 *   Author : https://evoqins.com
 *   Description : Risk profile status modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';

// Assets
import RiskProfileMisMatch from "../../Assets/Images/Modal/risk-profile-mismatch.webp";

//Custom components
import { PrimaryButton } from '../Buttons';
import SecondaryButton from '../Buttons/secondary-button';

const RiskProfileStatusModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("risk-profile-status-modal-close");
        button.click();
    };

    // handle success
    const _handleContinue = () => {
        _handleCloseModal();
        props.handleContinue();
    };

    // handle success
    const _handleRetake = () => {
        _handleCloseModal();
        props.handleRetake();
    };

    return (
        <div className="modal fade"
            id="risk-profile-status-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="subscriptionModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5`}>
                <span id='risk-profile-status-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 overflow-hidden border-0 mx-lg-5">
                    {/* {
                        props.type === 1 &&
                        <h3 className='px-3 pt-2 e-alt-font-lato e-font-16 e-text-outer-space e-font-weight-700 line-height-24px'>
                            Recommended Risk Score
                        </h3>
                    } */}
                    <div className='modal-body px-3 py-4 text-center'>
                        <img src={RiskProfileMisMatch}
                            draggable={false}
                            width={200}
                            alt='risk profile mismatch image' />

                        <h4 className='padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px'>
                            {
                                props.type === 1 ? "Successfully Completed the Risk Profile" : "Risk Profile Mismatch"
                            }
                        </h4>
                        {
                            props.type === 1 ?
                                <div>
                                    <p className='e-alt-font-lato e-font-18 e-text-outer-space e-font-weight-600 line-height-20px mb-3 mt-3'>
                                        Risk type : {props.riskData.riskCategoryName}
                                    </p>
                                    <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                                        Based on a risk score, {props.riskData.riskCategoryDescription}
                                    </p>
                                </div>
                                :
                                <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                                    This<span className='e-font-weight-600 px-1'>{props.basketName}</span>
                                    product is designed for<span className='e-font-weight-600 px-1'>{props.basketRiskInfo.risk_category_name}</span>
                                    wealth creation. Your risk profile is<span className='e-font-weight-600 px-1'>{props.riskData.riskCategoryName},</span>
                                    which doesn't align with this product's objectives. Would you like to proceed or view baskets that match your risk profile?
                                </p>
                        }
                    </div>
                    {/* Modal footer */}
                    <div className='modal-footer border-0 px-3 pb-3'>
                        <div className="d-flex w-100 gap-2">
                            {
                                props.type !== 1 &&
                                <SecondaryButton name={"Retake"}
                                    className="h-48 flex-1 w-50"
                                    onPress={_handleRetake} />
                            }
                            <PrimaryButton name={"Continue"}
                                className="h-48 flex-1 w-50 ms-auto flex-fill"
                                onPress={_handleContinue} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

RiskProfileStatusModal.defaultProps = {
    handleClose: () => { },
};

export default memo(RiskProfileStatusModal);
